import React from 'react'
import Countdown from 'react-countdown'

const Timer = () => {
  const renderer=({hours,minutes,seconds})=>{
        return(
          <div>{hours}:{minutes}:{seconds}</div>
        )
  }
  return (
    <>
      <div className='h-[50px] bg-gradient-to-r from-indigo-200 from-10% via-sky-200 via-30% to-emerald-200 to-90% flex items-center justify-center space-x-2'>
        <div className=''>Sale ends in </div>
        <div className='font-bold'>
            <Countdown date={Date.now() + 5.04e+7} renderer={renderer} ></Countdown>
        </div>
        <img src={require('../../Images/sale2.jpg')} alt="" className='h-[50px]'/>
      </div>
    </>
  )
}

export default Timer
